// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2WaSd","errors":"Errors_errors__29Mzt"};